import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

export const onStreamingEarlyStopCardShown: (
	props: commonAttributesType,
) => AnalyticsEventPayload = (props: commonAttributesType): AnalyticsEventPayload => {
	const { query, source } = props;
	return {
		action: 'shown',
		actionSubject: 'aiAnswerStreamingEarlyStopCard',
		source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
		},
		nonPrivacySafeAttributes: {
			query,
		},
	};
};
